require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/slick.js");
require("./vendor/tab.js");
require("./vendor/modal.js");
require("./vendor/TweenMax.min.js");
require("./vendor/wp_nav.es6");
require("./vendor/scriptbreaker-multiple-accordion.js");

require("./custom/wp_nav.es6");
require("./custom/footer.es6");

(function ($) {

    $(".section_home_banner_slider .slick-slider").length > 0 && require("./custom/banner-slider.es6");

    $(".section_slider_section .slick-slider, .section_slider_section_type_2 .slick-slider").length > 0 && require("./custom/image-slider.es6");

    $(".section_goals_section .read-more").length > 0 && require("./custom/services.es6");

    $(".section_slider_section_type_1 .slick-slider").length > 0 && require("./custom/section_slider_section_type_1.es6");

    $(".section_info_blocks_type_2").length > 0 && require("./custom/section_info_blocks_type_2.es6");

    $(".single-services").length > 0 && require("./custom/single-service.es6");

    $(".section_praxis_info").length > 0 && require("./custom/section_praxis_info.es6");

    $(".section-vacancies").length > 0 && require("./custom/section_vacancies.es6");

    $(".section_block_type_5, .section_block_type_6").length > 0 && require("./custom/services-blocks-5-6.es6");

})(jQuery);